import * as React from 'react';
import clsx from 'clsx';
import styles from './inline-button.module.css';

export interface InlineButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    testId?: string;
}

/** An unstyled native button that inherits its font and colour, with the ui focus ring. */
export const InlineButton = React.forwardRef<HTMLButtonElement, InlineButtonProps>((props, ref) => {
    const { type = 'button', className, testId, ...rest } = props;

    return (
        <button
            ref={ref}
            type={type}
            className={clsx(styles['inline-button'], className)}
            data-testid={testId}
            {...rest}
        />
    );
});

InlineButton.displayName = 'InlineButton';
